module.exports = __webpack_public_path__ + "static/media/DK_Favicon.d5e0c999.png";